import React from "react";
import L from "leaflet";
import HeatmapLayer from "react-leaflet-heatmap-layer";
import { Map, ImageOverlay } from "react-leaflet";
import "./App.css";
import { dataPoints } from "./Data.js";
import "leaflet/dist/leaflet.css";
import Navbar from "./Components/Common/Navbar";

var bounds = [
  [1000, 0],
  [0, 1000],
];



const App = () => {
  return (
    <div className=".leaflet-container">
      <Map
        className=""
        crs={L.CRS.Simple}
        bounds={bounds}
        maxZoom={5}
        // scrollWheelZoom={false}
        onzoomstart={(e) => console.log(e)}
        attributionControl={false}
      >
        <HeatmapLayer
          points={dataPoints}
          longitudeExtractor={(m) => m.coordinates[0]}
          latitudeExtractor={(m) => m.coordinates[1]}
          intensityExtractor={(m) => 100}
        />
        <ImageOverlay
          url={"https://www.bragitoff.com/wp-content/uploads/2015/11/GTAV-HD-MAP-satellite.jpg"}
          bounds={[
            [1000, 0],
            [0, 1250],
          ]}
        />
      </Map>
    </div>
  );
};
export default App;
